var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-content-roles-and-permission"}},[_c('roles-table'),_c('permissions-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }